import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useScheduleRequestFeaturesAccess } from './use-schedule-request-features-access';

export const useScheduleActivityAccess = () => {
  const [isScheduleActivityWetagEnabled, isLoadingScheduleActivityWetag] = ScheduleOrg.useWetag('schedule-activity');

  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { hasScheduleRequestFeaturesAccess, isLoading: isLoadingScheduleRequestAccess } =
    useScheduleRequestFeaturesAccess();

  const isEnabled = isScheduleV3FlagEnabled && hasScheduleRequestFeaturesAccess && isScheduleActivityWetagEnabled;
  const isLoading = isLoadingV3Flag || isLoadingScheduleRequestAccess || isLoadingScheduleActivityWetag;

  return {
    isScheduleActivityEnabled: !isLoading && isEnabled,
    isLoading,
  };
};
